export const getNextLineNum = cart => {
  if (cart.length === 0) return 1
  const maxLineNum = cart.reduce(
    (max, item) => Math.max(max, Number(item.LineNum) || 0),
    0
  )
  return maxLineNum + 1
}
